import "core-js/modules/es.array.concat.js";
import React from 'react';
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/react";

var container = function container(theme) {
  return {
    border: "1px solid ".concat(theme.gray100),
    backgroundColor: theme.white,
    marginBottom: '1.5em'
  };
};

var totalRow = function totalRow(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1.2em 2em',
    backgroundColor: theme.gray50,
    borderBottom: "1px solid ".concat(theme.gray100),
    '& .total-label': {
      fontSize: '1.4rem',
      fontWeight: 600,
      color: theme.gray700,
      textTransform: 'uppercase',
      letterSpacing: '0.04em'
    },
    '& .total-value': {
      fontSize: '1.8rem',
      fontWeight: 700,
      color: theme.primary
    }
  };
};

var grid = function grid(theme) {
  return {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    '& > div:not(:last-of-type)': {
      borderRight: "1px solid ".concat(theme.gray100)
    },
    '@media (max-width: 900px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      '& > div:nth-of-type(2n)': {
        borderRight: 'none'
      },
      '& > div:nth-of-type(n+3)': {
        borderTop: "1px solid ".concat(theme.gray100)
      }
    },
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr',
      '& > div': {
        borderRight: 'none',
        borderTop: 'none',
        borderBottom: "1px solid ".concat(theme.gray100)
      },
      '& > div:last-of-type': {
        borderBottom: 'none'
      }
    }
  };
};

var section = {
  padding: '1.4em 2em'
};

var sectionTitle = function sectionTitle(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5em',
    marginBottom: '1em',
    '& i': {
      fontSize: '1.5rem',
      color: theme.primary
    },
    '& span': {
      fontSize: '1.2rem',
      fontWeight: 600,
      color: theme.gray400,
      textTransform: 'uppercase',
      letterSpacing: '0.04em'
    }
  };
};

var row = function row(theme) {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.5em 0',
    '& .label': {
      fontSize: '1.3rem',
      color: theme.gray400
    },
    '& .value': {
      fontSize: '1.3rem',
      fontWeight: 600,
      color: theme.gray700
    }
  };
};

var fmt = function fmt(val, cur) {
  return "".concat(val !== null && val !== void 0 ? val : '--', " ").concat(cur);
};

var CurrentMonthValuesList = function CurrentMonthValuesList(_ref) {
  var data = _ref.data,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? '' : _ref$currency;
  return ___EmotionJSX("div", {
    css: container
  }, ___EmotionJSX("div", {
    css: totalRow
  }, ___EmotionJSX("span", {
    className: "total-label"
  }, "\u041E\u0431\u0449\u043E \u0437\u0430 \u0442\u0435\u043A\u0443\u0449\u0438\u044F \u043C\u0435\u0441\u0435\u0446"), ___EmotionJSX("span", {
    className: "total-value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total, currency))), ___EmotionJSX("div", {
    css: grid
  }, ___EmotionJSX("div", {
    css: section
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-coins"
  }), ___EmotionJSX("span", null, "\u0413\u043B\u0430\u0432\u043D\u0438\u0446\u0438")), ___EmotionJSX("div", {
    css: row
  }, ___EmotionJSX("span", {
    className: "label"
  }, "\u0421\u044A\u0431\u0440\u0430\u043D\u0438"), ___EmotionJSX("span", {
    className: "value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total_paid_principals, currency))), ___EmotionJSX("div", {
    css: row
  }, ___EmotionJSX("span", {
    className: "label"
  }, "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u0438"), ___EmotionJSX("span", {
    className: "value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total_late_principals, currency))), ___EmotionJSX("div", {
    css: row
  }, ___EmotionJSX("span", {
    className: "label"
  }, "\u041E\u0447\u0430\u043A\u0432\u0430\u043D\u0438"), ___EmotionJSX("span", {
    className: "value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total_future_principals, currency))), ___EmotionJSX("div", {
    css: row
  }, ___EmotionJSX("span", {
    className: "label"
  }, "\u041E\u0431\u0449\u043E"), ___EmotionJSX("span", {
    className: "value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total_principals, currency)))), ___EmotionJSX("div", {
    css: section
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-percentage"
  }), ___EmotionJSX("span", null, "\u041B\u0438\u0445\u0432\u0438")), ___EmotionJSX("div", {
    css: row
  }, ___EmotionJSX("span", {
    className: "label"
  }, "\u0421\u044A\u0431\u0440\u0430\u043D\u0438"), ___EmotionJSX("span", {
    className: "value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total_paid_interests, currency))), ___EmotionJSX("div", {
    css: row
  }, ___EmotionJSX("span", {
    className: "label"
  }, "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u0438"), ___EmotionJSX("span", {
    className: "value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total_late_interests, currency))), ___EmotionJSX("div", {
    css: row
  }, ___EmotionJSX("span", {
    className: "label"
  }, "\u041E\u0447\u0430\u043A\u0432\u0430\u043D\u0438"), ___EmotionJSX("span", {
    className: "value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total_future_interests, currency))), ___EmotionJSX("div", {
    css: row
  }, ___EmotionJSX("span", {
    className: "label"
  }, "\u041E\u0431\u0449\u043E"), ___EmotionJSX("span", {
    className: "value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total_interests, currency)))), ___EmotionJSX("div", {
    css: section
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-receipt"
  }), ___EmotionJSX("span", null, "\u0422\u0430\u043A\u0441\u0438")), ___EmotionJSX("div", {
    css: row
  }, ___EmotionJSX("span", {
    className: "label"
  }, "\u0421\u044A\u0431\u0440\u0430\u043D\u0438"), ___EmotionJSX("span", {
    className: "value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total_paid_fees, currency))), ___EmotionJSX("div", {
    css: row
  }, ___EmotionJSX("span", {
    className: "label"
  }, "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u0438"), ___EmotionJSX("span", {
    className: "value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total_late_fees, currency))), ___EmotionJSX("div", {
    css: row
  }, ___EmotionJSX("span", {
    className: "label"
  }, "\u041E\u0447\u0430\u043A\u0432\u0430\u043D\u0438"), ___EmotionJSX("span", {
    className: "value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total_future_fees, currency))), ___EmotionJSX("div", {
    css: row
  }, ___EmotionJSX("span", {
    className: "label"
  }, "\u041E\u0431\u0449\u043E"), ___EmotionJSX("span", {
    className: "value"
  }, fmt(data === null || data === void 0 ? void 0 : data.total_fees, currency))))));
};

CurrentMonthValuesList.propTypes = {
  data: PropTypes.object,
  currency: PropTypes.string
};
export default CurrentMonthValuesList;